import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import * as dotenv from 'dotenv';

dotenv.config();
export const apiInternal = axios.create({
  baseURL: process.env.REACT_APP_API_INTERNAL_URL
});
